export const errorCodeToErrorMessageMapping = {
  ExclusiveColumnsSelected: _TL_('Restricted column or filter combinations selected.'),
  InvalidId: _TL_('The report does not exist or does not belong to current user, manager account or account.'),
  InvalidEmail: _TL_('Invalid email address'),
  InvalidScope: _TL_("You don't have access to current manager account or account. Please choose another manager account or account."),
  TaskSchedulingInvalid: _TL_('End date cannot be earlier than start date, and given frequency must be executable at least once'),
  TaskThrottlingLimitReached: _TL_('You have reached the maximum allowed number of running reports. Please wait for the reports to finish and try again later.'),
  DatabaseTimeout: _TL_('This report has more data than we can show here. Please reduce the scope or download it.'),
  NotSupported: _TL_('Not supported.'),
  ReportGridFilterDataValueNotSupported: _TL_('The filter value is not supported.'),
  AccountNotAuthorized: _TL_('The specified report request contains at least one account which you have insufficient privileges to access. Please submit a report request for accounts that you are authorized to access.'),
};

export const userErrorCodes = Object.keys(errorCodeToErrorMessageMapping);
